import request from '@/api/request'

export type SiteSettingsMap = Record<string, string>

export function fetchSiteSettings() {
  return request.get<SiteSettingsMap>('/api/admin/system/settings')
}

export function saveSiteSettings(body: SiteSettingsMap) {
  return request.put<{ status: number; msg: string }>('/api/admin/system/settings', body)
}

export function uploadAdminSystemImage(file: File) {
  const fd = new FormData()
  fd.append('file', file)
  return request.post<{ status: number; url?: string; msg?: string }>('/api/admin/system/uploads/image', fd)
}
